<template>
    <div>
        <vue-scroll :ops="$ops" style="height:400px">
            <el-form :model="classForm" label-width="70px">
                <el-row :span="16" >
                    <el-col :span="12" v-for="student in $parentInfo.Dialog_SingClass.students">
                        <el-form-item  :label="student.student_name" :key="student.student_id">
                            <el-select v-model="student.status" placeholder="请选择状态">
                                <el-option
                                        v-for="item in status_types"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </vue-scroll>
        <div style="text-align: right">
            <el-button @click="handleSignAll"  :loading="$parentInfo.Dialog_SingClass.button_loading">确定</el-button>
            <el-button @click="handleSignClassPlan" :loading="$parentInfo.Dialog_SingClass.button_loading">全部签到</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_SignClass",
        data() {
            return {
                classForm:{

                },
                students:[
                    {
                        id:1,
                        name:'学生1',
                        status:'active'
                    },
                    {
                        id:2,
                        name:'学生2',
                        status:'active'
                    },
                    {
                        id:3,
                        name:'学生2',
                        status:'active'
                    },
                    {
                        id:4,
                        name:'学生2',
                        status:'active'
                    },
                    {
                        id:5,
                        name:'学生2',
                        status:'active'
                    },
                    {
                        id:6,
                        name:'学生2',
                        status:'active'
                    }
                ],
                status_types:[{
                    id: 'active',
                    name: '未上'
                },{
                    id: 'finished',
                    name: '签到'
                },{
                    id: 'absent',
                    name: '缺席'
                }],
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
        },
        methods: {
            handleSignAll(){
                this.$parentInfo.Dialog_SingClass.button_loading=true;
                this.$wApi.send(this.$parentInfo.signPath, 'signLog_classPlan', {
                    'classPlan_id': this.$parentInfo.Dialog_SingClass.classPlan_id,
                    'classPlan_students': this.$parentInfo.Dialog_SingClass.students,
                });
            },
            handleSignClassPlan(){
                this.$parentInfo.Dialog_SingClass.button_loading=true;
                this.$wApi.send(this.$parentInfo.signPath,'changeType', {
                        'classPlan_id':this.$parentInfo.Dialog_SingClass.classPlan_id,
                        'student_id':0,
                        'status':'finished',
                        'type':'many'});
            }
        }
    }
</script>

<style scoped>

</style>